// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"279a140b","453":"3584416c"}[chunkId] + ".chunk.js";
};